import { LottoDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { NuovaCampagnaReducerType } from "./types";

const nuovaCampagnaReducer = (state: RootState) => state.nuovaCampagna;


export const lottoCaricatoSelector = createSelector(
  nuovaCampagnaReducer,
  (state: NuovaCampagnaReducerType): LottoDto | undefined => {
    return state.lottoCaricato;
  }
)

export const dataInizio = createSelector(
  nuovaCampagnaReducer,
  (state: NuovaCampagnaReducerType): Date => {
    return state.dataInizio;
  }
);

export const dataFine = createSelector(
  nuovaCampagnaReducer,
  (state: NuovaCampagnaReducerType): Date => {
    return state.dataFine;
  }
);